import React, { PureComponent } from "react";
import { Modal } from "antd";
import PropTypes from "prop-types";
import "../../assets/stylus/com/feedback/modal.styl";
import { hocAddProps } from "@/hoc/hocComponent";
import _ from "lodash";
import { closeModals } from "../../state/action/comAction";

class scModalCore extends PureComponent {
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      currentModals: [],
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.initStore();
  }

  initStore(s) {
    const store = s || this.context.store;
    if (store) {
      store.subscribe(() => {
        // 打开或关闭普通窗口
        console.log(this.state.currentModals[0]);
        // 过滤非显示隐藏的触发
        if (
          !this.state.currentModals[0]
          || store.getState().modalInfo.visible !== this.state.currentModals[0].visible
        ) {
          this.state.currentModals = [store.getState().modalInfo];
          this.setState({
            currentModals: [...this.state.currentModals],
          });
        }
      });
    }
  }

  addStackModal(key, param) {
    const newModal = _.find(this.props.config, (m) => {
      return m.key === key;
    });
    newModal["stack"] = !0;
    newModal["visible"] = !0;
    newModal["stackParam"] = param;
    this.state.currentModals.push(newModal);
    this.setState({
      currentModals: [...this.state.currentModals],
    });
  }

  onCancel(cm) {
    // 关闭堆叠窗口
    if (cm.stack) {
      _.remove(this.state.currentModals, (n) => {
        return cm === n;
      });
      this.setState({
        currentModals: [...this.state.currentModals],
      });
    } else {
      // 关闭普通窗口
      this.context.store.dispatch(closeModals());
    }
  }

  render() {
    const childModals = this.state.currentModals;
    const modals = this.props.config.map((config) => {
      const CM = childModals.map((cm) => {
        const Content = hocAddProps(config.content, {
          openStack: this.addStackModal.bind(this),
          closeStack: () => {
            this.onCancel(cm);
          },
          stack: cm.stack,
          stackParam: cm.stackParam,
        });
        return (
          cm.key === config.key // 匹配Key
          && cm.visible && ( // 匹配是否显示
            <Modal
              key={config.key}
              width={config.width}
              title={config.title}
              visible={cm.visible}
              onCancel={() => {
                this.onCancel(cm);
              }}
              wrapClassName="vertical-center-modal"
              footer={null}>
              <Content />
            </Modal>
          )
        );
      });
      return CM;
    });
    return <div>{modals}</div>;
  }
}

export default scModalCore;

scModalCore.propsType = {
  config: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/AntD/components/feedback/scModalMulterCore.js